"use strict";

exports.__esModule = true;
exports.default = recursiveUnbracket;

/**
 * Parse a bracket-style string to an usable object.
 */
function recursiveUnbracket(str) {
  return str.split("[").map(s => s.endsWith("]") ? s.slice(0, -1) : s);
}